<ng-container *transloco="let t; read: 'cabinets'">
  <ng-container *transloco="let tGlobal">
    @if (vm$ | async; as vm) {
      <div class="componentContainer">
        <section class="xs12col componentHeader">
          <h1>{{t('title')}}</h1>
        </section>
        <section class="oneCol">
          <div class="xs12col">
            <div class="boxContainer">
              <div class="box">
                <div class="xs12col">
                  <kendo-grid
                    [data]="vm.cabinets"
                    [skip]="vm.gridState.skip"
                    [pageSize]="vm.gridState.pageSize"
                    [pageable]="true"
                    [loading]="loading"
                    (pageChange)="pageChangeSub$.next($event)"
                    class="xs12col">
                    <kendo-grid-column field="name" [title]="t('name')" media="(min-width: 993px)">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.name || '' }}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="location" [title]="t('location')" media="(min-width: 993px)">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.location || '' }}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="numberOfSlots" [title]="t('numberOfSlots')" media="(min-width: 993px)">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{ dataItem.slots.length }}
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-command-column
                      [hidden]="('Permissions.Cabinets.SearchGlobal' | permission)"
                      media="(min-width: 993px)">
                      <ng-template
                        kendoGridCellTemplate
                        let-isNew="isNew"
                        let-dataItem>
                        <a
                          [routerLink]="[dataItem.id]"
                          [attr.tooltip]="t('open')"
                          flow="up"
                          class="actionIcon">
                          <img src="../../../assets/icons/open-link-icon.svg">
                        </a>
                      </ng-template>
                    </kendo-grid-command-column>
                    <kendo-grid-command-column
                      [hidden]="!('Permissions.Cabinets.SearchGlobal' | permission)"
                      media="(min-width: 993px)">
                      <ng-template
                        kendoGridCellTemplate
                        let-isNew="isNew"
                        let-dataItem>
                        <a
                          [routerLink]="['cabinets-admin/' + dataItem.id]"
                          [attr.tooltip]="t('open')"
                          flow="up"
                          class="actionIcon">
                          <img src="../../../assets/icons/open-link-icon.svg">
                        </a>
                      </ng-template>
                    </kendo-grid-command-column>
                    <!-- MOBILE GRID -->
                    <kendo-grid-column-group media="(max-width: 992px)">
                      <kendo-grid-column>
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <h4 class="mobileGridHeader">{{t('name')}}</h4>
                          {{dataItem.name || '' }}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column>
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <h4 class="mobileGridHeader">{{t('location')}}</h4>
                          {{dataItem.location || '' }}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column>
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <h4 class="mobileGridHeader">{{t('numberOfSlots')}}</h4>
                          {{dataItem.numberOfSlots || '' }}
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-command-column
                        [hidden]="!('Permissions.Cabinets.Search' | permission)">
                        <ng-template
                          kendoGridCellTemplate
                          let-isNew="isNew"
                          let-dataItem>
                          <a
                            [routerLink]="[dataItem.id]"
                            [attr.tooltip]="t('open')"
                            flow="up"
                            class="actionIcon">
                            <img src="../../../assets/icons/open-link-icon.svg">
                          </a>
                        </ng-template>
                      </kendo-grid-command-column>
                    </kendo-grid-column-group>
                    <!-- Paging -->
                    <ng-template
                      let-totalPages="totalPages"
                      let-currentPage="currentPage"
                      kendoPagerTemplate>
                      <div class="flex flexDirCol gridPagination">
                        <div class="flex flexDirRow gridRow">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-numeric-buttons
                            [buttonCount]="5"
                          ></kendo-pager-numeric-buttons>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        </div>
                        <div class="gridRow">
                          <label for="pageBtnGroup">{{t('resultsPerPage')}}</label>
                          <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
                            <button
                              (click)="pageChangeSub$.next({
                                skip: vm.gridState.skip,
                                take: pageSizes.Small
                              })"
                              kendoButton
                              [selected]="vm.gridState.pageSize === pageSizes.Small"
                              [toggleable]="true"
                              >
                              {{ pageSizes.Small }}
                            </button>
                            <button
                              (click)="pageChangeSub$.next({
                                skip: vm.gridState.skip,
                                take: pageSizes.Medium
                              })"
                              kendoButton
                              [selected]="vm.gridState.pageSize === pageSizes.Medium"
                              [toggleable]="true"
                              >
                              {{ pageSizes.Medium }}
                            </button>
                            <button
                              (click)="pageChangeSub$.next({
                                skip: vm.gridState.skip,
                                take: pageSizes.Large
                              })"
                              kendoButton
                              [selected]="vm.gridState.pageSize === pageSizes.Large"
                              [toggleable]="true"
                              >
                              {{ pageSizes.Large }}
                            </button>
                          </kendo-buttongroup>
                          <button
                            kendoButton
                            [title]="t('refresh')"
                            class="reloadIcon"
                            (click)="searchRequest$.next(vm.searchRequest)">
                            <img class="actionIcon" src="../assets/icons/reload.svg">
                          </button>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template kendoGridNoRecordsTemplate>
                      <div class="text pl">{{t('noResults')}}</div>
                    </ng-template>
                    <ng-template kendoGridLoadingTemplate>
                      <div class="k-loading-color"></div>
                      <div class="loading-container">
                        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                      </div>
                    </ng-template>
                  </kendo-grid>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    }
  </ng-container>
</ng-container>